(() => {
  class ModaliceHelpCenter extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.search = this.querySelector('[data-zhc-search]');
      this.clear = this.querySelector('[data-zhc-clear]');
      this.reset = this.querySelector('[data-zhc-reset]');
      this.status = this.querySelector('[data-zhc-status]');
      this.empty = this.querySelector('[data-zhc-empty]');
      this.faq = this.querySelector('[data-zhc-faq]');
      this.items = [...this.querySelectorAll('[data-zhc-question]')];
      this.categories = [...this.querySelectorAll('[data-zhc-category]')];
      this.activeCategory = '';

      this.search?.addEventListener('input', () => {
        this.activeCategory = '';
        this.render();
      });
      this.clear?.addEventListener('click', () => {
        this.search.value = '';
        this.activeCategory = '';
        this.render();
        this.search.focus();
      });
      this.reset?.addEventListener('click', () => {
        this.search.value = '';
        this.activeCategory = '';
        this.render();
      });
      this.categories.forEach((button) => button.addEventListener('click', () => {
        const selected = button.dataset.zhcCategory || '';
        this.activeCategory = this.activeCategory === selected ? '' : selected;
        this.search.value = '';
        this.render();
        this.faq?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }));
      this.querySelectorAll('details').forEach((details) => details.addEventListener('toggle', () => {
        if (!details.open) return;
        this.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      }));

      this.render();
    }

    normalize(value) {
      return (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    }

    render() {
      const query = this.normalize(this.search?.value);
      let visible = 0;

      this.items.forEach((item) => {
        const matchesSearch = query && this.normalize(item.dataset.search).includes(query);
        const matchesCategory = this.activeCategory && item.dataset.category === this.activeCategory;
        const shouldShow = query ? matchesSearch : this.activeCategory ? matchesCategory : item.dataset.popular === 'true';
        item.hidden = !shouldShow;
        if (shouldShow) visible += 1;
        if (!shouldShow) item.querySelector('details').open = false;
      });

      this.categories.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.zhcCategory === this.activeCategory));
      });

      if (this.clear) this.clear.hidden = !query;
      if (this.reset) this.reset.hidden = !query && !this.activeCategory;
      if (this.empty) this.empty.hidden = visible !== 0;

      if (this.status) {
        if (query) this.status.textContent = `${visible} ${visible === 1 ? 'pergunta encontrada' : 'perguntas encontradas'} para “${this.search.value.trim()}”.`;
        else if (this.activeCategory) this.status.textContent = `${visible} ${visible === 1 ? 'pergunta neste assunto' : 'perguntas neste assunto'}.`;
        else this.status.textContent = 'As dúvidas mais buscadas por nossas clientes.';
      }
    }
  }

  if (!customElements.get('modalice-help-center')) {
    customElements.define('modalice-help-center', ModaliceHelpCenter);
  }
})();
